import { call, takeLatest } from "redux-saga/effects";
import * as poApis from "../apis/poApis";
import {
  GENERATE_PO,
  PO_CSV_DOWNLOAD,
  PO_CSV_MAIL,
  PO_DISTRIBUTOR_LIST,
  PO_LIST,
  PO_OFFERTYPE_LIST,
  PO_STATE_LIST,
  PO_VIEW,
} from "../actions/types";

export function* poListWorker(action) {
  try {
    const res = yield call(poApis?.poListApi, action.data);
    console.log(res);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError(error);
  }
}

export function* poCsvDownloadWorker(action) {
  try {
    const res = yield call(poApis?.poCsvDownloadApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError(error);
  }
}

export function* poStateListWorker(action) {
  try {
    console.log(action);
    const res = yield call(poApis?.poStateListApi, action.data);
    if (res.status == 200) {
      let newArr = res.data.data.map((ele) => ({
        value: ele.id,
        label: ele.name,
      }));
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError(error);
  }
}

export function* poDistributorListWorker(action) {
  try {
    const res = yield call(poApis?.poDistributorListApi, action.data);
    // console.log(res , "response");
    if (res.status == 200) {
      let newArr = res.data.data.map((ele) => ({
        value: ele.distributor.id,
        label: ele.distributor.firm_name,
      }));
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError(error);
  }
}

export function* poOfferTypeWorker(action) {
  try {
    const res = yield call(poApis?.poOfferTypeListApi, action?.id);
    if (res.status == 200) {
      let newArr = res.data.data.map((ele) => ({
        value: ele.offer_type,
        label: ele.offer_type,
      }));
      yield action.onSuccess(newArr);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError(error);
  }
}

export function* generatePoInvoiceWorker(action) {
  try {
    const res = yield call(poApis?.generatePoInvoiceApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError(error);
  }
}
export function* poCsvSendMailWorker(action) {
  try {
    const res = yield call(poApis?.poCsvSendMailApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError(error);
  }
}


export function* poViewWorker(action) {
  try {
    const res = yield call(poApis?.poViewApi, action.data);
    if (res.status == "200") {
      yield action.onSuccess(res);
    } else {
      yield action.onError(res);
    }
  } catch (error) {
    yield action.onError(error);
  }
}

export function* poListWatcher() {
  yield takeLatest(PO_LIST, poListWorker);
}
export function* poCsvDownloadWatcher() {
  yield takeLatest(PO_CSV_DOWNLOAD, poCsvDownloadWorker);
}
export function* poStateListWatcher() {
  yield takeLatest(PO_STATE_LIST, poStateListWorker);
}
export function* poDistributorListWatcher() {
  yield takeLatest(PO_DISTRIBUTOR_LIST, poDistributorListWorker);
}
export function* poOfferTypeListWatcher() {
  yield takeLatest(PO_OFFERTYPE_LIST, poOfferTypeWorker);
}
export function* generatePoInvoiceWatcher() {
  yield takeLatest(GENERATE_PO, generatePoInvoiceWorker);
}
export function* poCsvSendMailWatcher() {
  yield takeLatest(PO_CSV_MAIL, poCsvSendMailWorker);
}
export function* poViewWatcher() {
  yield takeLatest(PO_VIEW, poViewWorker);
}